import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import { BrowserRouter } from 'react-router-dom';
import App from './app';
import {store} from './appStore/store'
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { xlmStateServer } from "./components/stellar/providers/xlmConnectors";

declare global {
  interface Window {
    rabet: any;
    cryoRioAccountServer?: xlmStateServer; // 👈️ turn off type checking
  }
}
ReactDOM.render(
    <Provider store={store}>
    <BrowserRouter>
    <App />
  </BrowserRouter>
  </Provider>
,
  document.getElementById('root')
);

reportWebVitals();
serviceWorker.unregister();